<template>
  <svg
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
  >
    <path
      d="M14 25.6667C20.4167 25.6667 25.6667 20.4167 25.6667 14C25.6667 7.58337 20.4167 2.33337 14 2.33337C7.58334 2.33337 2.33334 7.58337 2.33334 14C2.33334 20.4167 7.58334 25.6667 14 25.6667Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M9.04166 14L12.3433 17.3017L18.9583 10.6984"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script setup>
defineOptions({ name: 'IconCheckCircle' })

const props = defineProps({
  width: {
    type: String,
    default: '28px'
  },
  height: {
    type: String,
    default: '28px'
  }
})
</script>
